import { TFunction } from 'i18next'
import { UserGroupType } from 'types/accounts'
import { UserGroups } from '../const'

export const mapTranslationsSubText = (groupName: UserGroupType, t: TFunction) => {
  switch (UserGroups[groupName]) {
    case UserGroups['Workspace Owner']:
      return t('teamMember.workspaceOwnerSubText')
    case UserGroups.Admin:
      return t('teamMember.adminSubText')
    case UserGroups.Collaborator:
      return t('teamMember.collaboratorSubText')
    case UserGroups['Pay-In Only']:
    case UserGroups['Pay-In Only ']:
      return t('teamMember.payInSubText')
    case UserGroups.Viewer:
      return t('teamMember.viewerSubText')
    case UserGroups.Compliance:
      return t('teamMember.complianceSubText')
    case UserGroups['Compliance-Plus']:
      return t('teamMember.compliancePlusSubText')
    default:
      return ''
  }
}
